module.exports = __webpack_public_path__ + "static/media/hotel.8fefae38.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/common/icon/hotel.png
// module id = 682
// module chunks = 0